export const formatINR = (amount) => {
    const num = Number(amount);
    if (isNaN(num)) return "₹0.00";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(num);
  };
  

  export const formatINRShort = (amount, withSymbol = true) => {
    const num = Number(amount);
    if (isNaN(num) || num === 0) return withSymbol ? "₹0" : "0";
  
    const fullFormatted = num.toLocaleString("en-IN");
  
    if (num >= 1e7) {
      const croreValue = Math.floor((num / 1e7) * 100) / 100;
      const short = withSymbol ? `₹${croreValue} Cr` : `${croreValue} Cr`;
      return  short;
    } else if (num >= 1e5) {
      const lakhValue = Math.floor((num / 1e5) * 100) / 100;
      const short = withSymbol ? `₹${lakhValue} L` : `${lakhValue} L`;
      return  short;
    } else {
      return withSymbol ? `₹${fullFormatted}` : fullFormatted;
    }
  };
  
  
  
  
